import React, { useEffect, useRef } from 'react';
import { ProgressLoader, ProgressLoaderHeader, ProgressLoaderBar, ProgressLoaderContent } from '..';
import { Text } from '@wix/design-system';
import styles from './StockingLoader.scss';
import { useProgressLoader } from '../../../headless';
function defaultContentRenderer(count) {
  if (count === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, `Selected ${count} premium products`);
}
export function StockingLoader(_ref) {
  let {
    isLoading,
    title,
    subtitle,
    statusMessages,
    totalCount = 20,
    onAnimationComplete,
    'aria-label': ariaLabel = 'Loading products',
    contentRenderer,
    progressUpdateInterval,
    progressIncrement,
    countUpdateInterval,
    countIncrement
  } = _ref;
  const statusMessageArray = Array.isArray(statusMessages) ? statusMessages : [statusMessages];

  // Ensure animation starts when component is rendered
  // If isLoading is false when component mounts, we still want to start the animation
  const hasStartedRef = useRef(false);
  const shouldAnimate = isLoading || !hasStartedRef.current;
  useEffect(() => {
    if (shouldAnimate) {
      hasStartedRef.current = true;
    }
  }, [shouldAnimate]);
  const renderContent = (_progress, count) => {
    if (contentRenderer) {
      return contentRenderer(count);
    }
    return defaultContentRenderer(count);
  };
  return /*#__PURE__*/React.createElement(ProgressLoader, {
    isLoading: shouldAnimate,
    totalCount: totalCount,
    statusMessageCount: statusMessageArray.length,
    onAnimationComplete: onAnimationComplete,
    progressUpdateInterval: progressUpdateInterval,
    progressIncrement: progressIncrement,
    countUpdateInterval: countUpdateInterval,
    countIncrement: countIncrement
  }, /*#__PURE__*/React.createElement(ProgressLoaderHeader, {
    title: title,
    subtitle: subtitle,
    className: styles.header,
    titleClassName: styles.title,
    subtitleClassName: styles.subtitle
  }), /*#__PURE__*/React.createElement(ProgressLoaderBar, {
    "aria-label": ariaLabel,
    showPercentage: false,
    fillColor: "#000000"
  }), /*#__PURE__*/React.createElement(StatusRow, {
    messages: statusMessages
  }), /*#__PURE__*/React.createElement(ProgressLoaderContent, null, renderContent));
}
function StatusRow(_ref2) {
  let {
    messages
  } = _ref2;
  const {
    statusMessageIndex,
    progress
  } = useProgressLoader();
  const messageArray = Array.isArray(messages) ? messages : [messages];
  const currentMessage = messageArray[statusMessageIndex] || messageArray[messageArray.length - 1];
  return /*#__PURE__*/React.createElement("div", {
    className: styles.statusRow
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    className: styles.statusText,
    role: "status",
    "aria-live": "polite",
    "aria-atomic": "true"
  }, currentMessage), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    className: styles.percentage
  }, Math.round(progress), "%"));
}
//# sourceMappingURL=StockingLoader.js.map